import { render, staticRenderFns } from "./IconsInfo.vue?vue&type=template&id=15d6cb3b&scoped=true&"
import script from "./IconsInfo.vue?vue&type=script&lang=ts&"
export * from "./IconsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./IconsInfo.vue?vue&type=style&index=0&id=15d6cb3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d6cb3b",
  null
  
)

export default component.exports